(function () {
  "use strict";
  var WHO = [
      { id: "jag", label: "Mig sj\xE4lv" },
      { id: "partner", label: "Min partner" },
      { id: "henne", label: "Henne" },
      { id: "honom", label: "Honom" },
      { id: "mamma", label: "Mamma" },
      { id: "pappa", label: "Pappa" },
      { id: "mormor", label: "Mormor eller farmor" },
      { id: "van", label: "En v\xE4n" },
      { id: "kollega", label: "En kollega eller personal" },
      { id: "oss", label: "Oss tv\xE5" },
      { id: "familj", label: "Hela familjen" },
      { id: "tonaring", label: "Ton\xE5ringen" },
    ],
    GROUP = ["oss", "familj"];
  function pron(who) {
    switch (who) {
      case "jag":
        return { subj: "du", obj: "dig", poss: "din" };
      case "henne":
      case "mamma":
      case "mormor":
        return { subj: "hon", obj: "henne", poss: "hennes" };
      case "honom":
      case "pappa":
        return { subj: "han", obj: "honom", poss: "hans" };
      case "oss":
      case "familj":
        return { subj: "ni", obj: "er", poss: "er" };
      default:
        return { subj: "hen", obj: "hen", poss: "hens" };
    }
  }
  function name(who) {
    var map = {
      partner: "din partner",
      mamma: "mamma",
      pappa: "pappa",
      mormor: "mormor eller farmor",
      van: "din v\xE4n",
      kollega: "din kollega",
      tonaring: "ton\xE5ringen",
    };
    return map[who] || null;
  }
  var NEEDS = [
      {
        id: "somn",
        label: "Varva ner och sova gott",
        text: "Lugn, v\xE4rme och en kv\xE4ll som landar mjukt",
      },
      {
        id: "kropp",
        label: "Mjuka upp kropp och muskler",
        text: "\xC5terh\xE4mtning efter en l\xE5ng dag eller tr\xE4ning",
      },
      {
        id: "hud",
        label: "Mjuk, \xE5terfuktad hud",
        text: "Omsorg f\xF6r ansikte och kropp",
      },
      {
        id: "har",
        label: "V\xE5rdat, glansigt h\xE5r",
        text: "En stund av h\xE5rv\xE5rd som p\xE5 salong",
      },
      {
        id: "tillsammans",
        label: "En mysig stund tillsammans",
        text: "Bad, massage och levande ljus",
        groupOnly: !0,
      },
    ],
    PLACES = [
      { id: "bad", label: "I badkaret" },
      { id: "dusch", label: "I duschen" },
      { id: "bastu", label: "I bastun" },
      { id: "soffa", label: "I soffan med ett ljus" },
    ],
    SCENTS = [
      { id: "lavendel", label: "Lavendel och \xF6rter" },
      { id: "citrus", label: "Citrus och citrongr\xE4s" },
      { id: "skog", label: "Skog och bj\xF6rk" },
      {
        id: "bar",
        label: "Nordiska b\xE4r",
        text: "Lingon, hjortron, bl\xE5b\xE4r, smultron",
      },
      { id: "blommigt", label: "Blommigt", text: "Ros och jasmin" },
      {
        id: "varmt",
        label: "Varmt och s\xF6tt",
        text: "Kokos, vanilj och bergamott",
      },
      {
        id: "friskt",
        label: "Friskt och svalt",
        text: "Mint, gurka och arktisk friskhet",
      },
      { id: "doftfritt", label: "Helst doftfritt" },
    ],
    EXPERIENCES = [
      {
        id: "vardag",
        label: "En liten vardagslyx",
        text: "N\xE5got enkelt att unna sig en vanlig tisdag",
      },
      {
        id: "kvall",
        label: "En lugn kv\xE4ll",
        text: "En hel ritual f\xF6r en kv\xE4ll hemma",
      },
      {
        id: "spadag",
        label: "En hel spadag hemma",
        text: "Den stora upplevelsen fr\xE5n topp till t\xE5",
      },
      {
        id: "present",
        label: "En present att packa upp",
        text: "F\xE4rdigt kit, fint att ge bort",
      },
    ],
    SKIN_TYPES = [
      { id: "torr", label: "Torr eller stram" },
      { id: "balanserad", label: "Balanserad eller normal" },
      { id: "fet", label: "Blank eller i obalans" },
    ],
    SKIN_SENSITIVITY = [
      { id: "ja", label: "Ja, välj extra varsamt" },
      { id: "nej", label: "Nej" },
      { id: "osaker", label: "Osäker" },
    ],
    SKIN_GOALS = [
      { id: "fukt", label: "Mer fukt och mjukhet" },
      { id: "lyster", label: "Lyster och näring" },
      { id: "balans", label: "Balans och en ren känsla" },
    ],
    HAIR_NEEDS = [
      { id: "torrt", label: "Fukt och mjukhet" },
      { id: "kanslig", label: "Känslig hårbotten" },
      { id: "volym", label: "Volym och en ren känsla" },
      { id: "fargat", label: "Färgbehandlat hår" },
    ],
    HAIR_TONES = [
      { id: "silver", label: "Blont, grått eller silver" },
      { id: "ovrigt", label: "Annan hårfärg" },
    ],
    BUDGETS = [
      { id: "under500", label: "Upp till 500 kr" },
      { id: "under900", label: "Upp till 900 kr" },
      { id: "flexibel", label: "Flexibel – bästa matchningen först" },
    ],
    IMG_BASE = "https://cdn.shopify.com/s/files/1/0806/4856/9159/files/",
    IMAGES = {
      need: {
        somn: "spa-stilleben-med-ljus-och-stenar-61279040471367.webp?v=1788166653",
        kropp:
          "gooday-massageoljor-pa-badkarskant-61279798690119.webp?v=1788171889",
        hud: "rosenserien-eye-patches-miljobild-v10.png?v=1790340198",
        har: "bruns-schampo-nr-02-med-harvard-61279521800519.webp?v=1788171243",
        tillsammans:
          "fotbad-med-olja-och-levande-ljus-61332141146439.webp?v=1788170483",
      },
      place: {
        bad: "vitt-badkar-med-badbricka-och-doftljus-61279062917447.webp?v=1788171278",
        dusch: "bruns-harvard-i-duschmiljo-61279524716871.webp?v=1788170373",
        bastu: "04-cloudberry-body-scrub-30ml.webp?v=1790329231",
        soffa: "torplyktan-kada-doftpinnar-miljobild-3.webp?v=1788772275",
      },
      scents: {
        lavendel:
          "gooday-lavendel-rumsspray-med-ljus-61324328862023.webp?v=1788170935",
        citrus: "02-body-shower-lemongrass-30ml.webp?v=1790329045",
        skog: "torplyktan-barrskog-doftpinnar-miljobild-1.webp?v=1788772036",
        bar: "08-body-shower-lingonberry-30ml.webp?v=1790329480",
        blommigt:
          "torplyktan-sommarfagring-oppet-doftljus-61279046893895.webp?v=1788167152",
        varmt: "05-body-lotion-blueberry-vanilla-fudge-30ml.webp?v=1790329352",
        friskt: "14-foot-cream-tea-tree-peppermint-10ml.webp?v=1790330286",
        doftfritt:
          "bruns-saltkram-n33-unscented-200-ml-hemmaspa-badrum.webp?v=1788601236",
      },
      exp: {
        vardag:
          "care-of-gerd-hand-cream-cloudberry-miljobild.webp?v=1788515771",
        kvall:
          "torplyktan-smultronstalle-doftljus-badkar-61279027757383.webp?v=1788125813",
        spadag:
          "gooday-hemmaspa-kit-pa-badbricka-61317783519559.webp?v=1788171814",
        present:
          "presentforpackning-cellofanpase-180x110x360-hampasnore-v3.png?v=1788964249",
      },
    },
    SLOTS = {
      badsalt: {
        role: "Badet",
        by: {
          lavendel: ["lavendel-salt-500ml"],
          citrus: [
            "rosa-himalayasalt-skrubb-citrongras-500g",
            "lavendel-salt-500ml",
          ],
        },
        def: ["lavendel-salt-500ml"],
      },
      dusch: {
        role: "Duschen",
        by: {
          lavendel: [
            "schampo-duschtval-pro-haircare-lavendel-500ml",
            "body-shower-rosemary",
          ],
          citrus: ["body-shower-lemongrass"],
          skog: ["body-shower-rosemary"],
          bar: [
            "body-shower-lingonberry",
            "body-shower-blueberry-vanilla-fudge",
          ],
          varmt: ["body-shower-blueberry-vanilla-fudge"],
          doftfritt: ["24-7-schampo-body-shower-200-ml"],
        },
        def: ["body-shower-lemongrass", "body-shower-lingonberry"],
      },
      ljus: {
        role: "St\xE4mningen",
        by: {
          lavendel: ["doftljus-lavendel-120g"],
          citrus: ["midnattssol-doftljus-150-g", "dagsmeja-doftljus-310-g"],
          skog: ["barrskog-doftljus-150-g", "kada-doftljus-150-g"],
          bar: ["smultronstalle-doftljus-150-g"],
          blommigt: ["sommarfagring-doftljus-150-g"],
          varmt: ["midvinter-doftljus-150-g"],
          friskt: ["rimfrost-doftljus-150-g", "norrsken-doftljus-150-g"],
        },
        def: ["smultronstalle-doftljus-150-g", "midvinter-doftljus-150-g"],
        skipIfUnscented: !0,
      },
      massage: {
        role: "Massagen",
        by: {
          lavendel: ["harmony-massage-oil-500ml"],
          citrus: ["massageolja-citrongras-500ml"],
          bar: ["lingonberry-massage-oil-500ml"],
          skog: ["arctic-massage-oil-500ml"],
          friskt: ["arctic-massage-oil-500ml"],
          blommigt: ["harmony-massage-oil-500ml"],
          varmt: ["harmony-massage-oil-500ml"],
          doftfritt: ["neutral-massage-oil-500ml"],
        },
        def: ["massageolja-citrongras-500ml", "harmony-massage-oil-500ml"],
      },
      lotion: {
        role: "Efter\xE5t",
        by: {
          lavendel: ["hand-kroppslotion-pro-bodycare-lavendel-500-ml"],
          citrus: [
            "body-lotion-lemongrass",
            "hand-kroppslotion-citrongras-500ml",
          ],
          bar: ["body-lotion-lingonberry"],
          varmt: ["body-lotion-blueberry-vanilla-fudge"],
          skog: ["c-o-gerd-24-7-body-lotion-200ml"],
          friskt: ["c-o-gerd-24-7-body-lotion-200ml"],
          doftfritt: ["c-o-gerd-24-7-body-lotion-200ml"],
        },
        def: ["body-lotion-lemongrass", "c-o-gerd-24-7-body-lotion-200ml"],
      },
      liniment: { role: "Musklerna", by: {}, def: ["muscle-liniment"] },
      ansiktsmask: {
        role: "Ansiktsmasken",
        by: {
          bar: ["cloudberry-facial-mask"],
          blommigt: ["organic-cotton-mask-anti-aging-and-moisturising"],
          doftfritt: [],
        },
        def: [
          "cloudberry-facial-mask",
          "organic-cotton-mask-anti-aging-and-moisturising",
        ],
      },
      ansiktsolja: {
        role: "Ansiktsoljan",
        by: { doftfritt: ["jojoba-oil"] },
        def: ["carrot-oil", "jojoba-oil"],
      },
      ogon: { role: "\xD6gonen", by: {}, def: ["eye-patches"] },
      ansiktsmist: {
        role: "Avslutningen",
        by: { blommigt: ["rose-water"], friskt: ["gronmist-n\xBA103"] },
        def: ["rose-water"],
      },
      harmask: {
        role: "H\xE5rinpackningen",
        by: {
          varmt: ["harmask-n\xBA22-warm-bergamot"],
          citrus: ["harmask-n\xBA22-warm-bergamot"],
          blommigt: ["harmask-n\xBA20-english-rose"],
          doftfritt: ["bruns-harmask-n23-unscented-350-ml"],
        },
        def: ["harmask-n\xBA22-warm-bergamot"],
      },
      schampo: {
        role: "Tv\xE4tten",
        by: {
          citrus: ["schampo-n\xBA04-magic-citrus"],
          blommigt: ["schampo-n\xBA02-spicy-jasmine"],
          varmt: ["schampo-n\xBA01-harmonious-coconut"],
          lavendel: ["schampo-pro-haircare-lavendel"],
          bar: ["lingonberry-shampoo", "blueberry-shampoo"],
          friskt: ["bruns-vaxaschampo-n80-lemon-mint-300-ml"],
          doftfritt: ["schampo-n\xBA05-unscented-n\xBA04"],
        },
        def: ["schampo-n\xBA04-magic-citrus"],
      },
      balsam: {
        role: "Balsamet",
        by: {
          citrus: ["balsam-n\xBA04-magic-citrus"],
          blommigt: ["balsam-n\xBA02-spicy-jasmine"],
          varmt: ["balsam-n\xBA01-harmonious-coconut"],
          lavendel: ["balsam-pro-haircare-500-ml"],
          bar: ["deep-impact-conditioner"],
          doftfritt: ["24-7-fragrance-free-conditioner-200ml"],
        },
        def: ["balsam-n\xBA04-magic-citrus"],
      },
      bastuskrubb: {
        role: "Bastun",
        by: { citrus: ["rosa-himalayasalt-skrubb-citrongras-500g"] },
        def: ["sauna-birch-scrub-200ml"],
      },
      handkram: {
        role: "Omtanken",
        by: {
          lavendel: ["hand-cream-shea"],
          bar: ["hand-cream-lingonberry", "hand-cream-cloudberry"],
        },
        def: ["hand-cream-cloudberry"],
      },
      necessar: {
        role: "F\xF6rpackningen",
        by: {},
        def: ["hemmaspa-nessesar"],
      },
    },
    RITUALS = {
      kvall: {
        title: "Kv\xE4llsritualen",
        tag: "kvall",
        intro:
          "En lugn ritual f\xF6r att varva ner, sl\xE4ppa dagen och somna gott.",
        slots: {
          bad: ["badsalt", "ljus", "lotion", "handkram"],
          dusch: ["dusch", "ljus", "lotion", "handkram"],
          soffa: ["ljus", "lotion", "handkram", "massage"],
        },
        steps: {
          bad: [
            "T\xE4nd ljuset och sl\xE4ck taklampan en halvtimme innan du vill sova.",
            "L\xF6s upp en n\xE4ve badsalt i varmt vatten och ligg kvar i 15\u201320 minuter.",
            "Klappa huden torr och sm\xF6rj in kroppen medan den fortfarande \xE4r varm.",
            "L\xE4gg undan telefonen och l\xE5t kv\xE4llen landa.",
          ],
          dusch: [
            "T\xE4nd ljuset och s\xE4nk tempot en stund innan l\xE4ggdags.",
            "Ta en varm, l\xE5ngsam dusch och andas in doften.",
            "Sm\xF6rj in kroppen med lugna r\xF6relser, uppifr\xE5n och ned.",
            "Avsluta med handkr\xE4m och g\xE5 direkt till s\xE4ngs.",
          ],
          soffa: [
            "T\xE4nd ljuset och s\xE4tt dig bekv\xE4mt med en filt.",
            "Massera in lotion i h\xE4nder och f\xF6tter i lugn takt.",
            "Andas djupt tre g\xE5nger och l\xE5t axlarna sjunka.",
            "L\xE5t ljuset brinna medan du l\xE4ser eller bara \xE4r.",
          ],
        },
        kits: [
          {
            handle: "hemmaspa-kit-\u2764-gooday",
            who: "*",
            exp: ["kvall", "spadag", "present"],
          },
        ],
      },
      aterhamtning: {
        title: "\xC5terh\xE4mtningen",
        tag: "aterhamtning",
        intro:
          "En ritual f\xF6r tr\xF6tta muskler och en kropp som beh\xF6ver mjukas upp.",
        slots: {
          bad: ["badsalt", "massage", "liniment", "ljus"],
          dusch: ["dusch", "massage", "liniment", "ljus"],
          soffa: ["massage", "liniment", "ljus", "lotion"],
        },
        steps: {
          bad: [
            "Ta ett varmt bad med badsalt i 15\u201320 minuter f\xF6r att v\xE4rma upp musklerna.",
            "V\xE4rm massageoljan mellan h\xE4nderna och massera med l\xE5nga, lugna tag.",
            "Ge extra omsorg \xE5t nacke, axlar och vader.",
            "Drick ett glas vatten och vila en stund efter\xE5t.",
          ],
          dusch: [
            "Duscha varmt och l\xE5t vattnet v\xE4rma upp musklerna.",
            "Massera in oljan medan huden fortfarande \xE4r varm och fuktig.",
            "Arbeta med cirkul\xE4ra r\xF6relser d\xE4r det k\xE4nns stelt.",
            "Vila en stund under en filt innan du g\xE5r vidare.",
          ],
          soffa: [
            "T\xE4nd ljuset och g\xF6r det varmt och bekv\xE4mt.",
            "V\xE4rm oljan i h\xE4nderna och massera f\xF6tter, vader och axlar.",
            "Ta hj\xE4lp av n\xE5gon f\xF6r ryggen om du kan.",
            "Avsluta med att ligga still i fem minuter.",
          ],
        },
        kits: [],
      },
      hud: {
        title: "Hudritualen",
        tag: "hud",
        intro: "En ansiktsritual anpassad efter hudens behov och dina val.",
        slots: {
          bad: ["ansiktsmask", "ogon", "ansiktsolja", "ansiktsmist"],
          dusch: ["ansiktsmask", "ogon", "ansiktsolja", "ansiktsmist"],
          soffa: ["ljus", "ansiktsmask", "ogon", "ansiktsolja", "ansiktsmist"],
          bastu: ["ansiktsmist", "ansiktsolja"],
        },
        steps: {
          bad: [
            "Reng\xF6r ansiktet och l\xE4gg p\xE5 ansiktsmasken innan du g\xE5r ned i badet.",
            "L\xE5t masken verka medan du badar och slappnar av.",
            "Sk\xF6lj av och tryck in n\xE5gra droppar ansiktsolja med fingertopparna.",
            "Sm\xF6rj in kroppen och avsluta med \xF6gonpatchar i tio minuter.",
          ],
          dusch: [
            "Reng\xF6r ansiktet och l\xE4gg p\xE5 masken medan du duschar.",
            "Sk\xF6lj av masken sist i duschen.",
            "Pressa in ansiktsoljan i fuktig hud.",
            "Sm\xF6rj in kroppen och l\xE5t huden vila.",
          ],
          soffa: [
            "Reng\xF6r ansiktet och l\xE4gg p\xE5 masken.",
            "L\xE4gg \xF6gonpatcharna och luta dig tillbaka i tio minuter.",
            "Ta bort masken och tryck in ansiktsolja.",
            "Avsluta med en ansiktsmist f\xF6r en frisk k\xE4nsla.",
          ],
        },
        kits: [],
      },
      har: {
        title: "H\xE5rspat",
        tag: "har",
        intro: "En salongsk\xE4nsla hemma f\xF6r v\xE5rdat, glansigt h\xE5r.",
        slots: {
          bad: ["schampo", "harmask", "balsam", "ljus"],
          dusch: ["schampo", "harmask", "balsam", "ljus"],
          soffa: ["schampo", "harmask", "balsam", "ljus"],
          bastu: ["schampo", "harmask", "balsam"],
        },
        steps: {
          bad: [
            "Tv\xE4tta h\xE5ret med schampot och krama ur vattnet.",
            "F\xF6rdela h\xE5rinpackningen fr\xE5n mitten av l\xE4ngderna och ut i topparna.",
            "L\xE5t den verka 10\u201320 minuter medan du badar.",
            "Sk\xF6lj ur och avsluta med balsam f\xF6r extra glans.",
          ],
          dusch: [
            "Tv\xE4tta h\xE5ret med schampot.",
            "L\xE4gg i h\xE5rinpackningen och l\xE5t den verka medan du duschar klart.",
            "Sk\xF6lj ur och anv\xE4nd balsam i l\xE4ngderna.",
            "Sk\xF6lj med svalt vatten sist f\xF6r extra glans.",
          ],
          soffa: [
            "Tv\xE4tta h\xE5ret och krama ur vattnet med en handduk.",
            "L\xE4gg i inpackningen och s\xE4tt upp h\xE5ret i en handduk.",
            "Luta dig tillbaka med ett ljus t\xE4nt i 20 minuter.",
            "Sk\xF6lj ur och avsluta med balsam.",
          ],
        },
        kits: [],
      },
      bastu: {
        title: "Basturitualen",
        tag: "bastu",
        intro: "En nordisk ritual med v\xE4rme, skrubb och doften av bj\xF6rk.",
        slots: { bastu: ["bastuskrubb", "massage", "lotion"] },
        steps: {
          bastu: [
            "V\xE4rm upp i bastun i 10\u201315 minuter.",
            "Skrubba kroppen med cirkul\xE4ra r\xF6relser och sk\xF6lj av.",
            "Svalka dig och vila, g\xE4rna ute i friska luften.",
            "Avsluta med massageolja eller lotion p\xE5 varm hud.",
          ],
        },
        kits: [],
      },
      tillsammans: {
        title: "Stunden tillsammans",
        tag: "tillsammans",
        intro:
          "En kv\xE4ll med bad, massage och levande ljus, f\xF6r att ta tid f\xF6r varandra.",
        slots: {
          bad: ["badsalt", "massage", "ljus", "lotion"],
          dusch: ["dusch", "massage", "ljus", "lotion"],
          soffa: ["massage", "ljus", "lotion", "handkram"],
          bastu: ["bastuskrubb", "massage", "lotion"],
        },
        steps: {
          bad: [
            "T\xE4nd ljusen och g\xF6r badrummet varmt och stilla.",
            "Bada tillsammans eller turas om.",
            "Ge varandra en massage med varm olja.",
            "Avsluta med lotion och en kopp te.",
          ],
          dusch: [
            "T\xE4nd ljusen och v\xE4lj musik ni b\xE5da tycker om.",
            "Duscha varmt och ta tid p\xE5 er.",
            "Ge varandra en massage med varm olja.",
            "Avsluta i soffan under samma filt.",
          ],
          soffa: [
            "T\xE4nd ljusen och g\xF6r det bekv\xE4mt i soffan.",
            "Turas om att massera h\xE4nder, f\xF6tter och axlar.",
            "Prata lugnt eller var bara tysta tillsammans.",
            "Avsluta med handkr\xE4m och l\xE4gg undan telefonerna.",
          ],
          bastu: [
            "Bada bastu tillsammans och ta pauser emellan.",
            "Skrubba varandras ryggar.",
            "Svalka er och vila.",
            "Avsluta med massage med varm olja.",
          ],
        },
        kits: [
          {
            handle: "spakit-for-oss",
            who: ["oss"],
            exp: ["kvall", "spadag", "present"],
          },
        ],
      },
    },
    COUNT = { vardag: 2, kvall: 3, spadag: 5, present: 3 },
    BUDGET_CAP = { under500: 5e4, under900: 9e4, flexibel: 1 / 0 },
    QUIZ_VERSION = "3.0.6",
    PRODUCT_RULES = {
      "sauna-birch-scrub-200ml": {
        handle: "sauna-birch-scrub",
        productId: 10147282157895,
        variantId: 51511134224711,
        scents: ["skog", "friskt"],
      },
      "24-7-schampo-body-shower-200-ml": {
        unscented: !0,
        sensitive: !0,
        hairNeeds: ["kanslig"],
      },
      "neutral-massage-oil-500ml": { unscented: !0, sensitive: !0 },
      "c-o-gerd-24-7-body-lotion-200ml": {
        unscented: !0,
        sensitive: !0,
      },
      "bruns-harmask-n23-unscented-350-ml": {
        unscented: !0,
        sensitive: !0,
        hairNeeds: ["torrt", "kanslig"],
      },
      "schampo-n\xBA05-unscented-n\xBA04": {
        unscented: !0,
        hairNeeds: ["volym"],
      },
      "24-7-fragrance-free-conditioner-200ml": {
        unscented: !0,
        sensitive: !0,
        hairNeeds: ["torrt", "kanslig"],
      },
      "bruns-silverschampo-n25-unscented-n24-300-ml": {
        unscented: !0,
        hairNeeds: ["fargat"],
        hairTones: ["silver"],
      },
      "bruns-silverbalsam-n25-unscented-n24-300-ml": {
        unscented: !0,
        hairNeeds: ["fargat"],
        hairTones: ["silver"],
      },
      "bruns-silvermask-n25-unscented-n24-350-ml": {
        unscented: !0,
        hairNeeds: ["fargat"],
        hairTones: ["silver"],
      },
      "organic-cotton-mask-anti-aging-and-moisturising": {
        skinGoals: ["fukt", "lyster"],
      },
      "purifying-clay-mask": {
        skinTypes: ["torr", "balanserad", "fet"],
        skinGoals: ["balans"],
        sensitive: !1,
      },
      "carrot-oil": {
        skinTypes: ["torr", "balanserad", "fet"],
        skinGoals: ["fukt", "lyster"],
      },
      "jojoba-oil": {
        unscented: !0,
        sensitive: !0,
        skinTypes: ["torr", "balanserad", "fet"],
        skinGoals: ["fukt", "balans"],
      },
      "eye-patches": { skinGoals: ["lyster", "fukt"] },
      "rose-water": { skinGoals: ["fukt", "balans"] },
    },
    KIT_RULES = {
      "hemmaspa-kit-\u2764-gooday": { scents: ["lavendel"] },
      "spakit-for-oss": { scents: ["lavendel", "skog"] },
    },
    SLOT_STEPS = {
      badsalt: {
        bad: "Lös upp badsaltet i varmt vatten och sjunk ned i 15–20 minuter.",
      },
      dusch: {
        dusch: "Duscha långsamt med kroppstvålen och skölj noggrant.",
      },
      ljus: {
        default: "Tänd ljuset på en säker plats och sänk belysningen.",
      },
      massage: {
        bastu: "När du har svalkat dig, massera in oljan på varm hud.",
        soffa: "Värm oljan mellan händerna och massera med lugna rörelser.",
        default: "Värm oljan mellan händerna och massera med långa, lugna tag.",
      },
      lotion: {
        bastu: "Avsluta med lotion när huden har svalnat något.",
        default: "Smörj in kroppen medan huden fortfarande är lätt fuktig.",
      },
      liniment: {
        default:
          "Arbeta in linimentet där kroppen känns stel och följ produktens anvisning.",
      },
      ansiktsmask: {
        bad: "Applicera ansiktsmasken på rengjord hud före badet och skölj av efter verkningstiden.",
        dusch:
          "Applicera ansiktsmasken på rengjord hud och skölj av den sist i duschen.",
        soffa:
          "Applicera ansiktsmasken på rengjord hud och luta dig tillbaka under verkningstiden.",
        bastu:
          "När du har svalkat dig efter bastun, applicera masken på rengjord hud.",
      },
      ansiktsolja: {
        default: "Tryck in några droppar ansiktsolja i lätt fuktig hud.",
      },
      ogon: {
        default:
          "Lägg ögonpatcharna under ögonen och låt dem verka enligt anvisningen.",
      },
      ansiktsmist: {
        bastu: "När huden har svalnat, återfukta ansiktet med misten.",
        default: "Avsluta med ansiktsmist.",
      },
      schampo: {
        bastu:
          "Efter att du har svalkat dig från bastun, tvätta håret med schampot.",
        default: "Tvätta håret med schampot och skölj noggrant.",
      },
      harmask: {
        bad: "Fördela hårmasken i längderna och låt den verka medan du badar.",
        dusch:
          "Fördela hårmasken i längderna och låt den verka medan du duschar klart.",
        soffa:
          "Fördela hårmasken i längderna, vira in håret och låt den verka.",
        bastu:
          "Efter schamponering, fördela hårmasken i längderna och låt den verka enligt anvisningen.",
      },
      balsam: {
        default: "Avsluta med balsam i längderna och skölj ur.",
      },
      bastuskrubb: {
        bastu:
          "Skrubba kroppen med cirkulära rörelser och skölj av utanför bastun.",
      },
      handkram: {
        default: "Avsluta med handkräm och låt händerna vila.",
      },
    },
    cache = {},
    rawCache = {};
  function ruleFor(ref) {
    return PRODUCT_RULES[ref] || {};
  }
  function variantSize(variant) {
    var title = String((variant && variant.title) || "")
        .toLowerCase()
        .replace(",", "."),
      match = title.match(/(\d+(?:\.\d+)?)\s*(ml|cl|l|g|kg)\b/);
    if (!match) return null;
    var value = Number(match[1]),
      unit = match[2];
    if (unit === "cl") value *= 10;
    if (unit === "l" || unit === "kg") value *= 1e3;
    return value;
  }
  function largestAvailableVariant(product) {
    return (
      (product.variants || [])
        .filter(function (variant) {
          return variant.available;
        })
        .sort(function (left, right) {
          var leftSize = variantSize(left),
            rightSize = variantSize(right);
          if (leftSize == null && rightSize == null) return 0;
          if (leftSize == null) return 1;
          if (rightSize == null) return -1;
          return rightSize - leftSize;
        })[0] || null
    );
  }
  function availableVariant(product) {
    return product.quizVariant || largestAvailableVariant(product);
  }
  function productPrice(product) {
    var variant = availableVariant(product);
    return variant ? Number(variant.price) : Number(product.price || 0);
  }
  function fetchRawProduct(ref) {
    if (rawCache[ref]) return rawCache[ref];
    var rule = ruleFor(ref),
      handle = rule.handle || ref;
    var root =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
      "/";
    return (
      (rawCache[ref] = fetch(
        root + "products/" + encodeURIComponent(handle) + ".js",
      )
        .then(function (r) {
          return r.ok ? r.json() : null;
        })
        .catch(function () {
          return null;
        })),
      rawCache[ref]
    );
  }
  function fetchProduct(ref) {
    if (cache[ref]) return cache[ref];
    var rule = ruleFor(ref);
    return (
      (cache[ref] = fetchRawProduct(ref).then(function (product) {
        if (!product) return null;
        if (rule.productId && Number(product.id) !== rule.productId) {
          console.warn("[Hemmaspa quiz] Fel produkt-ID för", ref);
          return null;
        }
        var variant = rule.variantId
          ? (product.variants || []).filter(function (item) {
              return Number(item.id) === rule.variantId && item.available;
            })[0]
          : largestAvailableVariant(product);
        if (!variant) return null;
        product.quizRef = ref;
        product.quizVariant = variant;
        return product;
      })),
      cache[ref]
    );
  }
  function money(cents) {
    return (
      (cents / 100).toLocaleString("sv-SE", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }) + " kr"
    );
  }
  var SOURCE = (function () {
      try {
        var q = new URLSearchParams(window.location.search);
        return q.get("src") || q.get("utm_source") || "direkt";
      } catch (e) {
        return "direkt";
      }
    })(),
    META = {
      quiz_start: ["trackCustom", "QuizStart"],
      quiz_complete: ["trackCustom", "QuizComplete"],
      quiz_email: ["track", "Lead"],
    };
  function metaTrack(name2, params, tries) {
    var m = META[name2];
    if (m)
      if (typeof window.fbq == "function")
        try {
          window.fbq(m[0], m[1], {
            content_name: "hitta_din_ritual",
            content_category: params.ritual || "",
            source: params.source || SOURCE,
          });
        } catch (e) {}
      else
        (tries || 0) < 5 &&
          setTimeout(function () {
            metaTrack(name2, params, (tries || 0) + 1);
          }, 1e3);
  }
  function track(name2, params) {
    ((params = params || {}),
      /^quiz_(start|complete|email)$/.test(name2) &&
        !params.source &&
        (params.source = SOURCE));
    try {
      typeof window.gtag == "function" && window.gtag("event", name2, params);
    } catch (e) {}
    try {
      window.Shopify &&
        Shopify.analytics &&
        Shopify.analytics.publish &&
        Shopify.analytics.publish(name2, params);
    } catch (e) {}
    metaTrack(name2, params);
  }
  function imgFor(overrides, key, id) {
    var o = overrides && overrides[key + "_" + id];
    if (o) return o;
    var f = IMAGES[key] && IMAGES[key][id];
    return f ? IMG_BASE + f + "&width=480" : "";
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;",
      }[c];
    });
  }
  function pickRitual(a) {
    return a.need === "tillsammans"
      ? "tillsammans"
      : a.place === "bastu" && (a.need === "somn" || a.need === "kropp")
        ? "bastu"
        : { somn: "kvall", kropp: "aterhamtning", hud: "hud", har: "har" }[
            a.need
          ] || "kvall";
  }
  function addCandidate(list, seen, ref, score) {
    if (!ref) return;
    if (seen[ref] == null) {
      seen[ref] = list.length;
      list.push({ ref: ref, score: score });
      return;
    }
    list[seen[ref]].score = Math.max(list[seen[ref]].score, score);
  }
  function profileRefsForSlot(slotId, a) {
    var refs = [];
    if (a.need === "hud") {
      if (slotId === "ansiktsmask" && a.skinGoal === "fukt")
        refs.push("organic-cotton-mask-anti-aging-and-moisturising");
      if (slotId === "ansiktsmask" && a.skinGoal === "lyster")
        refs.push("organic-cotton-mask-anti-aging-and-moisturising");
      if (slotId === "ansiktsmask" && a.skinGoal === "balans")
        refs.push("purifying-clay-mask");
      if (slotId === "ansiktsolja" && a.skinGoal === "lyster")
        refs.push("carrot-oil");
      if (
        slotId === "ansiktsolja" &&
        (a.skinGoal === "fukt" || a.skinGoal === "balans")
      )
        refs.push("jojoba-oil");
      if (slotId === "ogon" && a.skinGoal === "lyster")
        refs.push("eye-patches");
      if (slotId === "ansiktsmist") refs.push("rose-water");
    }
    if (a.need === "har") {
      if (a.hairTone === "silver") {
        if (slotId === "schampo")
          refs.push("bruns-silverschampo-n25-unscented-n24-300-ml");
        if (slotId === "harmask")
          refs.push("bruns-silvermask-n25-unscented-n24-350-ml");
        if (slotId === "balsam")
          refs.push("bruns-silverbalsam-n25-unscented-n24-300-ml");
      }
      if (a.hairNeed === "kanslig") {
        if (slotId === "schampo") refs.push("24-7-schampo-body-shower-200-ml");
        if (slotId === "harmask")
          refs.push("bruns-harmask-n23-unscented-350-ml");
        if (slotId === "balsam")
          refs.push("24-7-fragrance-free-conditioner-200ml");
      }
      if (a.hairNeed === "torrt") {
        if (slotId === "harmask")
          refs.push("bruns-harmask-n23-unscented-350-ml");
        if (slotId === "balsam")
          refs.push("24-7-fragrance-free-conditioner-200ml");
      }
      if (a.hairNeed === "volym" && slotId === "schampo")
        refs.push("schampo-n\xBA05-unscented-n\xBA04");
    }
    return refs;
  }
  function candidatesFor(slotId, a) {
    var slot = SLOTS[slotId],
      list = [],
      seen = {},
      unscented = a.scents.indexOf("doftfritt") > -1;
    profileRefsForSlot(slotId, a).forEach(function (ref, index) {
      addCandidate(list, seen, ref, 140 - index);
    });
    if (unscented) {
      (slot.by.doftfritt || []).forEach(function (ref, index) {
        addCandidate(list, seen, ref, 120 - index);
      });
      return list;
    }
    (a.scents || []).forEach(function (scent, scentIndex) {
      (slot.by[scent] || []).forEach(function (ref, index) {
        addCandidate(list, seen, ref, 100 - scentIndex * 5 - index);
      });
    });
    (slot.def || []).forEach(function (ref, index) {
      addCandidate(list, seen, ref, 30 - index);
    });
    return list;
  }
  function candidateEligible(candidate, product, a) {
    var rule = ruleFor(candidate.ref),
      unscented = a.scents.indexOf("doftfritt") > -1;
    if (!product || !availableVariant(product)) return !1;
    if (unscented && rule.unscented !== !0) return !1;
    if (a.need === "hud" && a.skinSensitivity === "ja") {
      if (rule.sensitive !== !0) return !1;
    }
    if (a.need === "har" && a.hairNeed === "kanslig") {
      if (rule.sensitive !== !0) return !1;
    }
    if (rule.hairTones && a.hairTone && rule.hairTones.indexOf(a.hairTone) < 0)
      return !1;
    return !0;
  }
  function candidateScore(candidate, a) {
    var rule = ruleFor(candidate.ref),
      score = candidate.score;
    if (rule.skinTypes && a.skinType) {
      score += rule.skinTypes.indexOf(a.skinType) > -1 ? 25 : -25;
    }
    if (rule.skinGoals && a.skinGoal) {
      score += rule.skinGoals.indexOf(a.skinGoal) > -1 ? 35 : -15;
    }
    if (rule.hairNeeds && a.hairNeed) {
      score += rule.hairNeeds.indexOf(a.hairNeed) > -1 ? 35 : -15;
    }
    if (rule.hairTones && a.hairTone) {
      score += rule.hairTones.indexOf(a.hairTone) > -1 ? 45 : -30;
    }
    return score;
  }
  function availableOptions(slotId, a) {
    var candidates = candidatesFor(slotId, a);
    return Promise.all(
      candidates.map(function (candidate) {
        return fetchProduct(candidate.ref).then(function (product) {
          if (!candidateEligible(candidate, product, a)) return null;
          return {
            slot: slotId,
            ref: candidate.ref,
            product: product,
            score: candidateScore(candidate, a),
          };
        });
      }),
    ).then(function (options) {
      return options.filter(Boolean).sort(function (left, right) {
        return (
          right.score - left.score ||
          productPrice(left.product) - productPrice(right.product)
        );
      });
    });
  }
  function chooseItems(slotOptions, limit, budget, requiredSlots) {
    var best = { items: [], score: -1 / 0, total: 0 };
    requiredSlots = requiredSlots || [];
    function visit(index, items, used, total, relevance) {
      if (index >= slotOptions.length || items.length >= limit) {
        var requiredCount = items.filter(function (item) {
            return requiredSlots.indexOf(item.slot) > -1;
          }).length,
          score =
            requiredCount * 1e6 +
            items.length * 1e4 +
            relevance * 10 -
            total / 100;
        if (score > best.score)
          best = { items: items.slice(), score: score, total: total };
        return;
      }
      visit(index + 1, items, used, total, relevance);
      slotOptions[index].options.forEach(function (option) {
        var key = String(option.product.id),
          price = productPrice(option.product);
        if (used[key] || total + price > budget) return;
        used[key] = !0;
        items.push(option);
        visit(
          index + 1,
          items,
          used,
          total + price,
          relevance + option.score + (slotOptions.length - index) * 100,
        );
        items.pop();
        delete used[key];
      });
    }
    visit(0, [], {}, 0, 0);
    return best;
  }
  function kitMatches(kit, a) {
    var rule = KIT_RULES[kit.handle],
      whoOk = kit.who === "*" || kit.who.indexOf(a.who) > -1,
      unscented = a.scents.indexOf("doftfritt") > -1;
    if (!rule || !whoOk || kit.exp.indexOf(a.exp) < 0) return !1;
    if (unscented) return rule.unscented === !0;
    if (a.skinSensitivity === "ja" || a.hairNeed === "kanslig")
      return rule.sensitive === !0;
    return a.scents.some(function (scent) {
      return rule.scents.indexOf(scent) > -1;
    });
  }
  function stepFor(slotId, place) {
    var copy = SLOT_STEPS[slotId];
    return copy ? copy[place] || copy.default || null : null;
  }
  function buildResult(a) {
    var rid = pickRitual(a),
      ritual = RITUALS[rid],
      place = a.place,
      slotIds = ritual.slots[place] ? ritual.slots[place].slice() : [],
      targetCount = COUNT[a.exp] || 3,
      limit = a.exp === "present" ? targetCount + 1 : targetCount,
      budget = BUDGET_CAP[a.budget] || BUDGET_CAP.flexibel,
      requiredSlots = place === "soffa" ? ["ljus"] : [],
      kitConfigs = (ritual.kits || [])
        .filter(function (kit) {
          return kitMatches(kit, a);
        })
        .sort(function (left, right) {
          return (left.who === "*") - (right.who === "*");
        });
    if (
      a.scents.indexOf("doftfritt") > -1 &&
      rid === "kvall" &&
      slotIds.indexOf("massage") < 0
    )
      slotIds.unshift("massage");
    if (!slotIds.length)
      return Promise.resolve({
        id: rid,
        ritual: ritual,
        place: place,
        steps: [],
        items: [],
        kit: null,
        notes: ["Vi saknar ännu en säker ritual för den valda platsen."],
      });
    if (a.exp === "present" && slotIds.indexOf("necessar") < 0)
      slotIds.push("necessar");
    return Promise.all([
      Promise.all(
        slotIds.map(function (slotId) {
          return availableOptions(slotId, a).then(function (options) {
            return { slot: slotId, options: options };
          });
        }),
      ),
      Promise.all(
        kitConfigs.map(function (kit) {
          return fetchProduct(kit.handle);
        }),
      ),
    ]).then(function (result) {
      var chosen = chooseItems(result[0], limit, budget, requiredSlots),
        kits = result[1].filter(Boolean),
        kit = null,
        notes = [],
        desired = Math.min(limit, slotIds.length);
      for (var i = 0; i < kits.length; i++) {
        if (productPrice(kits[i]) <= budget) {
          kit = kits[i];
          break;
        }
      }
      if (a.scents.indexOf("doftfritt") > -1)
        notes.push(
          "Alla rekommendationer är verifierat oparfymerade. Produkter med okänd doftstatus har sorterats bort.",
        );
      if (chosen.items.length < desired)
        notes.push(
          "Vi visar hellre färre säkra matchningar än att fylla ut ritualen med något som inte passar dina svar.",
        );
      if (kitConfigs.length && !kit)
        notes.push(
          "Det färdiga kitet är inte tillgängligt eller klarar inte dina val, så vi visar en egenkomponerad ritual.",
        );
      if (a.budget !== "flexibel")
        notes.push("Produktvalen ryms inom din valda budget.");
      return {
        id: rid,
        ritual: ritual,
        place: place,
        steps: chosen.items
          .map(function (item) {
            return stepFor(item.slot, place);
          })
          .filter(Boolean),
        items: chosen.items,
        kit: kit,
        notes: notes,
      };
    });
  }
  function blankAnswers() {
    return {
      who: null,
      need: null,
      skinType: null,
      skinSensitivity: null,
      skinGoal: null,
      hairNeed: null,
      hairTone: null,
      place: null,
      scents: [],
      exp: null,
      budget: null,
    };
  }
  function normalizeDependentAnswers(key, value, answers) {
    if (key === "need") {
      if (value !== "hud") {
        answers.skinType = null;
        answers.skinSensitivity = null;
        answers.skinGoal = null;
      }
      if (value !== "har") {
        answers.hairNeed = null;
        answers.hairTone = null;
      }
    }
    if (key === "hairNeed" && value !== "fargat") answers.hairTone = null;
  }
  function Quiz(root) {
    ((this.root = root),
      (this.body = root.querySelector("[data-quiz-body]")),
      (this.progress = root.querySelector("[data-quiz-progress]")),
      (this.answers = blankAnswers()),
      (this.step = 0),
      (this.started = !1));
    try {
      this.images = JSON.parse(root.getAttribute("data-quiz-images") || "{}");
    } catch (e) {
      this.images = {};
    }
    try {
      var vem = new URLSearchParams(window.location.search).get("vem");
      vem &&
        WHO.some(function (w) {
          return w.id === vem;
        }) &&
        ((this.answers.who = vem),
        (this.step = 1),
        (this.started = !0),
        track("quiz_start", { quiz: "hitta_din_ritual" }),
        track("quiz_step", {
          quiz: "hitta_din_ritual",
          step: "who",
          value: vem,
        }));
    } catch (e) {}
    this.render();
  }
  ((Quiz.prototype.steps = function () {
    var a = this.answers,
      p = pron(a.who || "jag"),
      nm = name(a.who),
      isMe = a.who === "jag",
      isGroup = GROUP.indexOf(a.who) > -1,
      needQ = isMe
        ? "Vad l\xE4ngtar du efter just nu?"
        : isGroup
          ? "Vad vill ni dela?"
          : "Vad skulle " + (nm || p.subj) + " uppskatta mest?",
      placeQ = isMe
        ? "Var blir din spa-stund?"
        : isGroup
          ? "Var blir er spa-stund?"
          : "Var blir " + p.poss + " spa-stund?",
      scentQ = isMe
        ? "Vilka dofter g\xF6r dig glad?"
        : isGroup
          ? "Vilka dofter gillar ni?"
          : "Vilka dofter tror du att " + (nm || p.subj) + " tycker om?";
    var steps = [
      { key: "who", q: "Vem \xE4r ritualen till?", opts: WHO, cols: 3 },
      {
        key: "need",
        q: needQ,
        opts: NEEDS.filter(function (o) {
          return !o.groupOnly || isGroup;
        }),
      },
    ];
    if (a.need === "hud")
      steps = steps.concat([
        { key: "skinType", q: "Hur känns huden oftast?", opts: SKIN_TYPES },
        {
          key: "skinSensitivity",
          q: "Är huden känslig eller lättirriterad?",
          opts: SKIN_SENSITIVITY,
        },
        {
          key: "skinGoal",
          q: "Vad vill du främst ge huden?",
          opts: SKIN_GOALS,
        },
      ]);
    if (a.need === "har") {
      steps.push({
        key: "hairNeed",
        q: "Vad behöver håret mest?",
        opts: HAIR_NEEDS,
      });
      if (a.hairNeed === "fargat")
        steps.push({
          key: "hairTone",
          q: "Vilken ton vill du vårda?",
          opts: HAIR_TONES,
        });
    }
    steps = steps.concat([
      { key: "place", q: placeQ, opts: PLACES },
      {
        key: "scents",
        q: scentQ,
        hint: "V\xE4lj en eller tv\xE5. Vi g\xE5r vidare n\xE4r du valt tv\xE5.",
        opts: SCENTS,
        multi: 2,
      },
      { key: "exp", q: "Vilken sorts upplevelse?", opts: EXPERIENCES },
      { key: "budget", q: "Vilken budget känns lagom?", opts: BUDGETS },
      { key: "email" },
    ]);
    return steps;
  }),
    (Quiz.prototype.render = function () {
      var steps = this.steps(),
        s = steps[this.step],
        total = steps.length - 1;
      if (
        (this.progress.style.setProperty(
          "--quiz-progress",
          Math.min(this.step / total, 1),
        ),
        this.progress.setAttribute(
          "aria-valuenow",
          Math.round(Math.min(this.step / total, 1) * 100),
        ),
        s.key === "email")
      )
        return this.renderEmail();
      var self = this,
        a = this.answers,
        html = '<div class="hq-step" data-step="' + this.step + '">';
      ((html +=
        '<p class="hq-count">Fr\xE5ga ' +
        (this.step + 1) +
        " av " +
        total +
        "</p>"),
        (html +=
          '<h2 class="hq-question h2" tabindex="-1">' + esc(s.q) + "</h2>"),
        s.hint && (html += '<p class="hq-hint">' + esc(s.hint) + "</p>"));
      var withImg = !!IMAGES[s.key];
      ((html +=
        '<div class="hq-options' +
        (s.cols === 3 ? " hq-options--3" : "") +
        (withImg ? " hq-options--img" : "") +
        '" role="' +
        (s.multi ? "group" : "radiogroup") +
        '">'),
        s.opts.forEach(function (o) {
          var selected = s.multi
              ? a.scents.indexOf(o.id) > -1
              : a[s.key] === o.id,
            src = withImg ? imgFor(self.images, s.key, o.id) : "";
          html +=
            '<button type="button" class="hq-option' +
            (src ? " hq-option--img" : "") +
            (selected ? " is-selected" : "") +
            '" data-value="' +
            o.id +
            '" role="' +
            (s.multi ? "checkbox" : "radio") +
            '" aria-checked="' +
            selected +
            '">' +
            (src
              ? '<span class="hq-option__media"><img src="' +
                esc(src) +
                '" alt="" width="480" height="360" loading="lazy" decoding="async"></span>'
              : "") +
            '<span class="hq-option__label">' +
            esc(o.label) +
            "</span>" +
            (o.text
              ? '<span class="hq-option__text">' + esc(o.text) + "</span>"
              : "") +
            "</button>";
        }),
        (html += '</div><div class="hq-nav">'),
        this.step > 0 &&
          (html +=
            '<button type="button" class="hq-back link" data-back>Tillbaka</button>'),
        s.multi &&
          (html +=
            '<button type="button" class="button" data-next' +
            (a.scents.length ? "" : " disabled") +
            ">N\xE4sta</button>"),
        (html += "</div></div>"),
        (this.body.innerHTML = html));
      var h = this.body.querySelector(".hq-question");
      (this.started && h && h.focus({ preventScroll: !0 }),
        this.body.querySelectorAll(".hq-option").forEach(function (btn) {
          btn.addEventListener("click", function () {
            var v = btn.getAttribute("data-value");
            if (
              (self.started ||
                ((self.started = !0),
                track("quiz_start", { quiz: "hitta_din_ritual" })),
              s.multi)
            ) {
              var i = a.scents.indexOf(v);
              (v === "doftfritt"
                ? (a.scents = i > -1 ? [] : ["doftfritt"])
                : ((a.scents = a.scents.filter(function (x) {
                    return x !== "doftfritt";
                  })),
                  i > -1
                    ? a.scents.splice(a.scents.indexOf(v), 1)
                    : (a.scents.length >= s.multi && a.scents.shift(),
                      a.scents.push(v))),
                self.render());
              var full =
                i < 0 &&
                (a.scents.length >= s.multi || a.scents[0] === "doftfritt");
              full &&
                setTimeout(function () {
                  self.steps()[self.step].key === "scents" &&
                    (track("quiz_step", {
                      quiz: "hitta_din_ritual",
                      step: "scents",
                      value: a.scents.join(","),
                    }),
                    self.step++,
                    self.render(),
                    self.scrollTop());
                }, 450);
            } else
              ((a[s.key] = v),
                normalizeDependentAnswers(s.key, v, a),
                s.key === "who" &&
                  GROUP.indexOf(v) < 0 &&
                  a.need === "tillsammans" &&
                  (a.need = null),
                track("quiz_step", {
                  quiz: "hitta_din_ritual",
                  step: s.key,
                  value: v,
                }),
                self.step++,
                self.render(),
                self.scrollTop());
          });
        }));
      var next = this.body.querySelector("[data-next]");
      next &&
        next.addEventListener("click", function () {
          (track("quiz_step", {
            quiz: "hitta_din_ritual",
            step: "scents",
            value: a.scents.join(","),
          }),
            self.step++,
            self.render(),
            self.scrollTop());
        });
      var back = this.body.querySelector("[data-back]");
      back &&
        back.addEventListener("click", function () {
          (self.step--, self.render(), self.scrollTop());
        });
    }),
    (Quiz.prototype.scrollTop = function () {
      var top = this.root.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollY > top && window.scrollTo({ top: top, behavior: "smooth" });
    }),
    (Quiz.prototype.renderEmail = function () {
      var self = this,
        form = this.root.querySelector(".hq-hidden-form"),
        html =
          '<div class="hq-step hq-email"><h2 class="hq-question h2" tabindex="-1">Din ritual \xE4r klar</h2><p class="hq-hint">F\xE5 ritualen med alla steg till din inkorg, s\xE5 har du den n\xE4ra till hands n\xE4r det \xE4r dags.</p><form class="hq-email__form" novalidate><div class="field"><input class="field__input" type="email" id="hq-email-' +
          this.root.id +
          '" name="email" autocomplete="email" placeholder="E-postadress" required><label class="field__label" for="hq-email-' +
          this.root.id +
          '">E-postadress</label></div><label class="hq-consent"><input type="checkbox" name="consent" checked> Ja, skicka ritualen och fler tips och nyheter fr\xE5n Hemmaspa.se. Du kan avregistrera dig n\xE4r du vill.</label><p class="hq-error" role="alert" hidden></p><button type="submit" class="button">F\xE5 ritualen p\xE5 e-post</button></form><button type="button" class="hq-skip link" data-skip>Visa ritualen utan att ange e-post</button><div class="hq-nav"><button type="button" class="hq-back link" data-back>Tillbaka</button></div></div>';
      ((this.body.innerHTML = html),
        this.body.querySelector(".hq-question").focus({ preventScroll: !0 }));
      var f = this.body.querySelector("form");
      (f.addEventListener("submit", function (e) {
        e.preventDefault();
        var email = f.email.value.trim(),
          err = f.querySelector(".hq-error");
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          ((err.textContent = "Skriv en giltig e-postadress."),
            (err.hidden = !1));
          return;
        }
        ((err.hidden = !0),
          f.consent.checked && form && self.subscribe(form, email),
          track("quiz_email", {
            quiz: "hitta_din_ritual",
            consent: f.consent.checked,
            ritual: pickRitual(self.answers),
          }),
          (self.pendingEmail = email),
          self.showResult());
      }),
        this.body
          .querySelector("[data-skip]")
          .addEventListener("click", function () {
            (track("quiz_email_skip", { quiz: "hitta_din_ritual" }),
              self.showResult());
          }),
        this.body
          .querySelector("[data-back]")
          .addEventListener("click", function () {
            (self.step--, self.render());
          }));
    }),
    (Quiz.prototype.subscribe = function (form, email) {
      var a = this.answers,
        tags = [
          "newsletter",
          "quiz",
          "quiz-version-" + QUIZ_VERSION,
          "quiz-" + RITUALS[pickRitual(a)].tag,
          "mottagare-" + a.who,
          "plats-" + a.place,
          "upplevelse-" + a.exp,
          "budget-" + a.budget,
          a.skinType ? "hudtyp-" + a.skinType : null,
          a.skinSensitivity ? "hudkanslig-" + a.skinSensitivity : null,
          a.skinGoal ? "hudmal-" + a.skinGoal : null,
          a.hairNeed ? "harbehov-" + a.hairNeed : null,
          a.hairTone ? "harton-" + a.hairTone : null,
        ]
          .filter(Boolean)
          .concat(
            a.scents.map(function (s) {
              return "doft-" + s;
            }),
          );
      ((form.querySelector('[name="contact[email]"]').value = email),
        (form.querySelector('[name="contact[tags]"]').value = tags.join(",")));
      var data = new FormData(form);
      fetch(form.action, {
        method: "POST",
        body: data,
        credentials: "same-origin",
        headers: { Accept: "text/html" },
      }).catch(function () {});
    }));
  var MAIL_ENDPOINT = "https://hemmaspa-ritual-mail.andreas-31c.workers.dev";
  ((Quiz.prototype.sendRitual = function (email, title, intro, res) {
    var avail = function (p) {
        var variant = availableVariant(p);
        return variant ? variant.id : null;
      },
      prod = function (p, role) {
        return {
          title: p.title,
          url: p.url,
          image: p.featured_image || "",
          price: productPrice(p),
          variant_id: avail(p),
          role: role,
        };
      },
      payload = {
        email: email,
        website: "",
        title: title,
        intro: intro,
        steps: res.steps,
        kit: res.kit ? prod(res.kit, "F\xE4rdigt kit") : null,
        items: res.items.map(function (x) {
          return prod(x.product, SLOTS[x.slot].role);
        }),
      },
      note = document.createElement("p");
    ((note.className = "hq-intro hq-sent"),
      note.setAttribute("role", "status"));
    var introEl = this.body.querySelector(".hq-intro");
    fetch(MAIL_ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    })
      .then(function (r) {
        return r.ok ? r.json() : { ok: !1 };
      })
      .then(function (j) {
        ((note.textContent = j.ok
          ? "Ritualen \xE4r p\xE5 v\xE4g till " + email + "."
          : "Vi kunde inte skicka mejlet just nu, men ritualen finns h\xE4r nedan."),
          track("quiz_email_sent", { quiz: "hitta_din_ritual", ok: !!j.ok }));
      })
      .catch(function () {
        ((note.textContent =
          "Vi kunde inte skicka mejlet just nu, men ritualen finns h\xE4r nedan."),
          track("quiz_email_sent", { quiz: "hitta_din_ritual", ok: !1 }));
      })
      .then(function () {
        introEl &&
          introEl.parentNode &&
          introEl.parentNode.insertBefore(note, introEl.nextSibling);
      });
  }),
    (Quiz.prototype.showResult = function () {
      var self = this,
        a = this.answers;
      (this.progress.style.setProperty("--quiz-progress", 1),
        (this.body.innerHTML =
          '<div class="hq-loading" role="status">Vi s\xE4tter ihop din ritual \u2026</div>'),
        buildResult(a).then(function (res) {
          track("quiz_complete", {
            quiz: "hitta_din_ritual",
            version: QUIZ_VERSION,
            ritual: res.id,
            who: a.who,
            place: a.place,
            experience: a.exp,
            budget: a.budget,
          });
          var r = res.ritual,
            p = pron(a.who),
            nm = name(a.who),
            forWhom =
              a.who === "jag"
                ? "f\xF6r dig"
                : GROUP.indexOf(a.who) > -1
                  ? "f\xF6r er"
                  : "f\xF6r " + (nm || p.obj),
            total = res.items.reduce(function (s, x) {
              return s + productPrice(x.product);
            }, 0),
            notesHtml = res.notes.length
              ? '<div class="hq-intro" role="status" aria-live="polite">' +
                res.notes
                  .map(function (note) {
                    return "<p>" + esc(note) + "</p>";
                  })
                  .join("") +
                "</div>"
              : "",
            stepsHtml = res.steps.length
              ? '<ol class="hq-ritual">' +
                res.steps
                  .map(function (step) {
                    return "<li>" + esc(step) + "</li>";
                  })
                  .join("") +
                "</ol>"
              : "",
            html =
              '<div class="hq-result"><p class="hq-count">Din ritual</p><h2 class="hq-question h1" tabindex="-1">' +
              esc(r.title) +
              " " +
              esc(forWhom) +
              '</h2><p class="hq-intro">' +
              esc(r.intro) +
              "</p>" +
              notesHtml +
              stepsHtml;
          if (
            (res.kit
              ? ((html +=
                  '<div class="hq-kit"><p class="hq-kit__eyebrow">Alternativ: f\xE4rdigt kit</p>' +
                  card(res.kit, "Färdigt alternativ") +
                  '<button type="button" class="button" data-add-kit="' +
                  availableVariant(res.kit).id +
                  '">L\xE4gg kitet i varukorgen</button></div>'),
                (html += '<h3 class="hq-sub">Bygg ritualen själv</h3>'))
              : (html += '<h3 class="hq-sub">Rekommenderade produkter</h3>'),
            (html +=
              '<div class="hq-products">' +
              res.items
                .map(function (x) {
                  return card(x.product, SLOTS[x.slot].role);
                })
                .join("") +
              "</div>"),
            res.items.length &&
              (html +=
                '<div class="hq-total"><span>Hela ritualen: ' +
                money(total) +
                '</span><button type="button" class="button' +
                (res.kit ? " button--secondary" : "") +
                '" data-add-all>L\xE4gg hela ritualen i varukorgen</button></div>'),
            (html +=
              '<p class="hq-error" role="alert" hidden></p><button type="button" class="hq-restart link" data-restart>G\xF6r om quizet</button></div>'),
            (self.body.innerHTML = html),
            self.body
              .querySelector(".hq-question")
              .focus({ preventScroll: !0 }),
            self.scrollTop(),
            self.pendingEmail)
          ) {
            var mailTo = self.pendingEmail;
            ((self.pendingEmail = null),
              self.sendRitual(mailTo, r.title + " " + forWhom, r.intro, res));
          }
          var addAll = self.body.querySelector("[data-add-all]");
          addAll &&
            addAll.addEventListener("click", function () {
              var items = res.items.map(function (x) {
                return {
                  id: availableVariant(x.product).id,
                  quantity: 1,
                };
              });
              self.addToCart(items, addAll, {
                ritual: res.id,
                type: "ritual",
                value: total / 100,
              });
            });
          var addKit = self.body.querySelector("[data-add-kit]");
          (addKit &&
            addKit.addEventListener("click", function () {
              self.addToCart(
                [
                  {
                    id: Number(addKit.getAttribute("data-add-kit")),
                    quantity: 1,
                  },
                ],
                addKit,
                {
                  ritual: res.id,
                  type: "kit",
                  value: productPrice(res.kit) / 100,
                },
              );
            }),
            self.body
              .querySelector("[data-restart]")
              .addEventListener("click", function () {
                ((self.answers = blankAnswers()),
                  (self.step = 0),
                  self.render(),
                  self.scrollTop());
              }));
        }));
      function card(p, role) {
        var img = p.featured_image
            ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, "$1$2")
            : "",
          sep = img.indexOf("?") > -1 ? "&" : "?",
          variant = availableVariant(p),
          variantTitle =
            variant && String(variant.title).toLowerCase() !== "default title"
              ? String(variant.title)
              : "",
          productUrl =
            p.url +
            (variant
              ? (p.url.indexOf("?") > -1 ? "&" : "?") + "variant=" + variant.id
              : "");
        return (
          '<a class="hq-card" href="' +
          productUrl +
          '">' +
          (img
            ? '<img class="hq-card__img" src="' +
              img +
              sep +
              'width=400" alt="' +
              esc(p.title) +
              '" width="400" height="400" loading="lazy">'
            : "") +
          '<span class="hq-card__role">' +
          esc(role) +
          '</span><span class="hq-card__title">' +
          esc(p.title + (variantTitle ? " – " + variantTitle : "")) +
          '</span><span class="hq-card__price">' +
          money(productPrice(p)) +
          "</span></a>"
        );
      }
    }),
    (Quiz.prototype.addToCart = function (items, btn, params) {
      var self = this,
        root =
          (window.Shopify &&
            window.Shopify.routes &&
            window.Shopify.routes.root) ||
          "/";
      ((btn.disabled = !0),
        btn.setAttribute("aria-busy", "true"),
        fetch(root + "cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            items: items,
            attributes: { quiz_ritual: params.ritual },
          }),
        })
          .then(function (r) {
            if (!r.ok) throw new Error("add");
            return r.json();
          })
          .then(function () {
            (track("quiz_add_to_cart", {
              quiz: "hitta_din_ritual",
              ritual: params.ritual,
              type: params.type,
              value: params.value,
              currency: "SEK",
            }),
              (window.location.href = root + "cart"));
          })
          .catch(function () {
            ((btn.disabled = !1), btn.removeAttribute("aria-busy"));
            var e = self.body.querySelector(".hq-error");
            e &&
              ((e.textContent =
                "N\xE5got gick fel. F\xF6rs\xF6k igen eller l\xE4gg till produkterna en och en."),
              (e.hidden = !1));
          }));
    }));
  function collectReferences() {
    var refs = [];
    function add(ref) {
      if (refs.indexOf(ref) < 0) refs.push(ref);
    }
    Object.keys(SLOTS).forEach(function (slotId) {
      var slot = SLOTS[slotId];
      (slot.def || []).forEach(add);
      Object.keys(slot.by || {}).forEach(function (scent) {
        (slot.by[scent] || []).forEach(add);
      });
    });
    Object.keys(RITUALS).forEach(function (ritualId) {
      (RITUALS[ritualId].kits || []).forEach(function (kit) {
        add(kit.handle);
      });
    });
    Object.keys(PRODUCT_RULES).forEach(add);
    return refs;
  }
  function validateReferences() {
    return Promise.all(
      collectReferences().map(function (ref) {
        return fetchRawProduct(ref).then(function (product) {
          var rule = ruleFor(ref);
          if (!product) return { ref: ref, status: "missing" };
          if (rule.productId && Number(product.id) !== rule.productId)
            return { ref: ref, status: "wrong_product" };
          if (
            rule.variantId &&
            !(product.variants || []).some(function (variant) {
              return Number(variant.id) === rule.variantId;
            })
          )
            return { ref: ref, status: "missing_variant" };
          return {
            ref: ref,
            status: product.available ? "available" : "unavailable",
          };
        });
      }),
    ).then(function (results) {
      results.forEach(function (result) {
        if (result.status === "missing")
          console.warn("[Hemmaspa quiz] Produktreferensen saknas:", result.ref);
        if (result.status === "wrong_product")
          console.warn("[Hemmaspa quiz] Produkt-ID stämmer inte:", result.ref);
        if (result.status === "missing_variant")
          console.warn("[Hemmaspa quiz] Varianten saknas:", result.ref);
        if (result.status === "unavailable")
          console.info(
            "[Hemmaspa quiz] Produkten är inte köpbar just nu:",
            result.ref,
          );
      });
      return results;
    });
  }
  function init() {
    document.querySelectorAll("[data-hemmaspa-quiz]").forEach(function (el) {
      el.__quiz || (el.__quiz = new Quiz(el));
    });
  }
  if (
    window.__HEMMASPA_QUIZ_TEST__ ||
    (window.Shopify && window.Shopify.designMode)
  ) {
    window.HemmaspaQuizDebug = {
      version: QUIZ_VERSION,
      buildResult: buildResult,
      blankAnswers: blankAnswers,
      validateReferences: validateReferences,
    };
  }
  if (window.Shopify && window.Shopify.designMode) validateReferences();
  (document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", init)
    : init(),
    document.addEventListener("shopify:section:load", init));
})();
